import {Trans} from '@lingui/macro';
import {Card, Layout} from 'antd';
import * as React from 'react';
import {connect} from 'react-redux';
import EurasiaLogo from '../../components/eurasia-logo';
import EurasiaTruck from '../../components/eurasia-truck';
import GlobalFooter from '../../components/global-footer';
import languages from '../../components/language-switch/languages';
import LoginForm from '../../containers/login-form';
import './login-page.less';


const {Content} = Layout;

const LoginPage = connect()(({dispatch}) => {

    const handleLogin = (loginData: any) => {
        console.log(loginData);

    };

    const footerLinks = languages(dispatch).map((lang, index) => ({
        title: <span key={index} onClick={lang.setLocale}>{lang.label}</span>,
    }));

    const footerCopyright = <Trans>All right reserved. Created by RF-IT Hungary Kft. | &copy; 2019</Trans>;

    const titleLogos = <><EurasiaLogo/><EurasiaTruck width={300}/></>

    return (
        <Layout className="login-page-layout">
            <Content>
                <Card className="login-page-card" title={titleLogos}>
                    <LoginForm onLogin={handleLogin} className="login-page-login-form"/>
                </Card>
            </Content>
            <GlobalFooter links={footerLinks} copyright={footerCopyright}/>
        </Layout>
    );
});

export default LoginPage;
